import Tooltip from 'components/Tooltip';
import React, { Fragment, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { Col, Button } from 'reactstrap';

const ConditionalTooltipWrapper = ({ tooltip, children }) => {
  useEffect(() => {
    if (tooltip) ReactTooltip.rebuild();
  }, []);
  return tooltip ? (
    <Tooltip tooltip={tooltip}>{children}</Tooltip>
  ) : (
    <Fragment>{children}</Fragment>
  );
};

const Filters = ({ showArchiveRepositories, setShowArchiveRepositories }) => {
  const handleClick = () => {
    setShowArchiveRepositories((prevState) => !prevState);
  };

  return (
    <Col className="text-right">
      <div className="d-inline">
        <ConditionalTooltipWrapper
          tooltip={`${
            showArchiveRepositories ? 'Hide' : 'Show'
          } archived repositories`}
        >
          <Button
            id="btnArchive"
            color="c2"
            size="sm"
            className="mt-0"
            onClick={handleClick}
          >
            <i
              className={`fa-solid ${
                showArchiveRepositories ? 'fa-eye-slash' : 'fa-eye'
              }`}
            ></i>
            {`${
              showArchiveRepositories ? ' Hide' : ' Show'
            } archived repositories`}
          </Button>
        </ConditionalTooltipWrapper>
      </div>
    </Col>
  );
};

export default Filters;
